import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';

export const ACCESS_REQUEST_CAPABILITIES = {
	ACCESS_GRANTED: 'ACCESS_GRANTED',
	ACCESS_EXISTS: 'ACCESS_EXISTS',
	DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
	DIRECT_ACCESS: 'DIRECT_ACCESS',
	FORBIDDEN: 'FORBIDDEN',
	PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
	REQUEST_ACCESS: 'REQUEST_ACCESS',
};

export const VALID_DIRECT_ACCESS_STATUS: string[] = [
	ACCESS_REQUEST_CAPABILITIES.ACCESS_EXISTS,
	ACCESS_REQUEST_CAPABILITIES.ACCESS_GRANTED,
	ACCESS_REQUEST_CAPABILITIES.PENDING_REQUEST_EXISTS,
];

export const ACCESS_DENIED_STATUSES: string[] = [
	ACCESS_REQUEST_CAPABILITIES.FORBIDDEN,
	ACCESS_REQUEST_CAPABILITIES.DENIED_REQUEST_EXISTS,
];

export const LICENCE_EXCEEDED_STATUS = 'licence-exceeded';

export const getParentProduct = (projectType?: string): 'JSM' | 'JSW' | 'JWM' => {
	switch (projectType) {
		case SERVICE_DESK_PROJECT:
			return 'JSM';
		case SOFTWARE_PROJECT:
			return 'JSW';
		case CORE_PROJECT:
			return 'JWM';
		default:
			return 'JSW';
	}
};
